<template>
  <div class="floating-chat">
    <OverlayPanel
      ref="overlaypanel"
      class="p-0"
      :pt="{
        content: {
          style: {
            backgroundColor: 'var(--primary-color)',
            color: 'white',
            borderRadius: '5px',
          },
        },
      }"
    >
      <div>
        {{ this.$root.lang("floating_chat_tooltip") }}<br /><br />
        {{ this.$root.lang("floating_chat_tooltip_sub") }}
      </div>
    </OverlayPanel>

    <Transition name="bubble">
      <div
        v-if="chatIsHidden"
        @click="toggleChat"
        @mouseover="showPopover"
        @mouseleave="hidePopover"
        style="cursor: pointer"
      >
        <i class="fa fa-comments floating-chat-bubble" aria-hidden="true"></i>
      </div>
    </Transition>
    <Transition name="chat">
      <div v-if="!chatIsHidden" class="chat">
        <div
          class="chat-header py-2 px-2 flex flex-row align-items-center justify-content-between"
        >
          <span class="title">
            {{ this.$root.lang("floating_chat_title") }}
          </span>
          <div 
            :style="`cursor:${isTyping ? 'not-allowed' : 'pointer'}`" 
            @click="toggleChat()">
            <i class="fa fa-times" aria-hidden="true"></i>
          </div>
        </div>
        <div class="chat-message" ref="chatMessage">
          <div class="row w-100">
            <div v-for="(msg, i) in messages" :key="i" class="col-12">
              <div v-if="msg.type == 'other'" class="flex flex-row">
                <Avatar
                  label="Forsis"
                  style="background-color: #dee9fc; color: #1a2551"
                  shape="circle"
                />
                <div class="flex-grow-1 ml-2">
                  <span class="other">
                    <span :id="`span-${msg.id}`" style="word-wrap: break-word" v-html="msg.message">
                    </span>
                    <br />
                    <span class="chat-time" style="float: right">
                      {{ msg.date ? getHoursMinute(msg.date) : "" }}
                    </span>
                  </span>
                </div>
              </div>
              <div v-else class="flex flex-row">
                <div class="flex-grow-1 mr-2">
                  <span class="self">
                    <span :id="`span-${msg.id}`" style="word-wrap: break-word">
                      {{ msg.message }}
                    </span>
                    <br />
                    <span class="chat-time">
                      {{ msg.date ? getHoursMinute(msg.date) : "" }}
                    </span>
                  </span>
                </div>
                <Avatar
                  label="U"
                  style="background-color: #dee9fc; color: #1a2551"
                  shape="circle"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="footer flex flex-row row-gap-2 mt-2 align-items-center">
          <InputText
            id="input-message"
            class="flex-grow-1 mr-2"
            style="height: 30px; text-transform: none !important"
            type="text"
            v-model="inputMessage"
          />
          <Button
            id="send-message-button"
            :disabled="isTyping"
            style="height: 30px; background-color: var(--chat-message-button)"
            @click="sendMessage()"
            label="Submit"
          >
            <i class="fa fa-paper-plane"></i>
          </Button>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
// import Card from "primevue/card";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Avatar from "primevue/avatar";
import config from "@/configs/config";
import OverlayPanel from "primevue/overlaypanel";
import { mapActions, mapState } from "pinia";
import { useGeneralStore } from "@/stores/GeneralStore";

export default {
  name: "FloatingChat",
  components: {
    // Card,
    Button,
    InputText,
    Avatar,
    OverlayPanel,
  },
  props: {
    items: Array,
  },
  data() {
    return {
      chatIsHidden: true,
      inputMessage: "",
      isAnswering: false,
      messages: [],

      arrBuffer: [],
      source: null,
      isTyping: false,
      count: 0,
      curSpanId: "",

      popoverShow: false,
    };
  },
  computed: {
    ...mapState(useGeneralStore, ["activeOwner"]),
  },
  methods: {
    ...mapActions(useGeneralStore, ["showGeneralDialog"]),

    toggleChat() {
      const vm = this;
      
      if(!vm.isTyping){
        vm.chatIsHidden = !vm.chatIsHidden;

        if(!vm.chatIsHidden){
          setTimeout(() => {
            vm.scrollMessageToBottom();
          }, 300)
        }
      }
    },
    getHoursMinute(date) {
      let datetext = "";
      if (date instanceof Date) {
        datetext =
          (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
          ":" +
          (date.getMinutes() < 10
            ? "0" + date.getMinutes()
            : date.getMinutes());
      }
      return datetext;
    },
    sendMessage() {
      const vm = this;

      if (vm.inputMessage && !vm.isTyping && !vm.isAnswering) {
        vm.count++;
        vm.messages.push({
          id: vm.count,
          type: "self",
          message: vm.inputMessage,
          date: new Date(),
        });

        vm.openStream();
      }
    },
    wait(time) {
      return new Promise((resolve) => {
        setTimeout(resolve, time);
      });
    },
    async TypingText() {
      const vm = this;
      // var result = 0,                            // variable with starting small letter
      // min, max;                              // helpers for keeping the found values
      vm.isTyping = true;
      if (document.getElementById(`span-${vm.count}`).innerHTML == "...") {
        document.getElementById(`span-${vm.count}`).innerHTML = "";
      }
      while (vm.arrBuffer.length) {
        // check against the length
        for (const c of vm.arrBuffer[0]) {
          document.getElementById(`span-${vm.count}`).innerHTML += c;
          await vm.wait(100);
        }
        document.getElementById(`span-${vm.count}`).innerHTML += " "; // update result
        vm.arrBuffer.splice(0, 1); // delete min value
        // arrBuffer.splice(arrBuffer.indexOf(max), 1);   // delete max value
      }
      vm.isTyping = false;
    },
    openStream() {
      const vm = this;
      let pquestion = vm.inputMessage;
      let datamin1 = "",
        checkdata = "";
      vm.inputMessage = "";

      vm.isAnswering = true;
      // vm.source = new EventSource(config.chatBotStreamUrl+"/question?inputchat="+encodeURI(pquestion))
      vm.source = new EventSource(
        vm.activeOwner.chatBotStreamUrl +
          "/inputChat?reqchat=" +
          encodeURI(pquestion)
      );

      vm.count++;
      vm.messages.push({
        id: vm.count,
        type: "other",
        message: "...",
        date: null,
      });
      vm.$nextTick(() => {
        vm.scrollMessageToBottom();
      });

      // source = new EventSource("http://nanika.spil.co.id:8081/stream")
      vm.source.onerror = (e) => console.log("Error:", e);
      vm.source.onmessage = (e) => {
        if (e.data !== "[DONE]") {
          vm.isTyping = true;
          let msg = vm.messages.find(x => x.id == vm.count);

          if(msg.message == "..."){
            msg.date = new Date(); //update date terbaru
            msg.message = "";
          }

          checkdata = datamin1 + e.data;

          if (checkdata == "\\n" || checkdata == "\\n\\n") {
            let tempHtml = document.getElementById(
              `span-${vm.count}`
            ).innerHTML;

            tempHtml = tempHtml.substring(0, tempHtml.length - 1);
            msg.message = msg.message = tempHtml + "<br>";
          } else {
            msg.message += e.data;
          }

          datamin1 = e.data;
          vm.scrollMessageToBottom();
        } else {
          vm.source.close();
          vm.isAnswering = false;
          vm.isTyping = false;
        }
      };
    },
    scrollMessageToBottom() {
      let container = this.$refs.chatMessage;
      if(container){
        container.scrollTop = container.scrollHeight;
      }
    },
    showPopover(event) {
      this.$refs.overlaypanel.show(event);
    },
    hidePopover() {
      this.$refs.overlaypanel.hide();
    },
  },
  mounted() {
    const vm = this;
    vm.source = new EventSource(config.chatBotStreamUrl + "/stream");

    document.body.onkeydown = function (e) {
      if (e.keyCode == "13" && document.activeElement.id == "input-message") {
        vm.sendMessage();
      }
    };
  },
};
</script>

<style scoped>
.floating-chat {
  position: absolute;
  bottom: 50px;
  right: 50px;
  z-index: 9999 !important;
}

.floating-chat-bubble {
  padding: 20px;
  border-radius: 50%;
  background-color: var(--primary-color);
  color: white;
}

.floating-chat-bubble:hover {
  background-color: var(--button-hover);
}

.chat {
  background-color: var(--primary-color);
  border-radius: 10px;
  padding: 10px;
}

.chat-header {
  color: white;
  font-weight: bold;
}

.chat-message {
  padding: 10px;
  height: 500px;
  width: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}

.other {
  background-color: var(--chat-message-background);
  float: left;
  max-width: 300px;
  min-width: 100px;
  color: white;
  padding: 5px;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 5px;
}

.self {
  background-color: var(--chat-message-background);
  float: right;
  max-width: 300px;
  min-width: 100px;
  color: white;
  padding: 5px;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 5px;
}

.chat-time {
  margin-top: 8px;
  font-size: 0.75rem;
  font-weight: 700;
  float: right;
}

@media (max-width: 768px) {
  .floating-chat {
    position: absolute;
    bottom: 20px;
    right: 20px;
  }
  .chat-message {
    height: 300px;
    width: 250px;
  }

  .self,
  .other {
    max-width: 170px !important;
    min-width: 50px !important;
  }
}

.message {
  width: 100%;
  display: block;
}

.bubble-enter-active,
.bubble-leave-active {
  transition: opacity 0.2s;
}

.bubble-enter-from,
.bubble-leave-to {
  transition: 0s;
  opacity: 0;
}

.chat-enter-active,
.chat-leave-active {
  transition: all 0.5s;
}

.chat-enter-from,
.chat-leave-to {
  transition: 0s;
  /* max-height: 0; */
  /* max-width: 0; */
  opacity: 0;
}

.title {
  color: white;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
  border-radius: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--secondary-color);
  transition: 0.2s;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: var(--primary-color);
  transition: 0.2s;
}
</style>
